// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"Pointer_modal-scroll__2pu_R","pointer":"Pointer_pointer___3gzX"};